import { type ReactNode } from 'react';
import { useActivePricing } from '@/hooks/use-pricing';
import type { CollectorSummary, DailyEarning } from '../types';
import { todayCount, computeBounds } from '../utils/today-count';
import { TodayBar } from './status-today-bar';

function Header({ today }: { today: number }): ReactNode {
  return (
    <div className="flex items-center justify-between text-[10px] text-text-tertiary/70">
      <span>Hoy</span>
      <span className="font-mono tabular-nums text-text-secondary">
        {today} creadores
      </span>
    </div>
  );
}

export function StatusToday({
  summary,
  daily,
}: {
  summary: CollectorSummary;
  daily: DailyEarning[] | undefined;
}): ReactNode {
  const { data: pricing } = useActivePricing();
  if (!pricing?.tiers.length) return null;
  const today = todayCount(daily);
  const bounds = computeBounds(
    pricing.tiers,
    today,
    summary.daily_minimum_leads ?? 33
  );
  return (
    <div className="mt-md space-y-2">
      <Header today={today} />
      <TodayBar today={today} bounds={bounds} />
    </div>
  );
}
